export const locale = {
    lang: 'zh2',
    data: {
      'PRINCIPAL': {
        'TITULO': '调查状态',
        'SUBTITULO': '您可以查看和跟进公司一项或多项产品所申请的调查信息',
        'COPY_URL_RES':'从 SuccesGo 复制 URL',
      },
      'MENU_PRODUCTOS': {
        'TITULO': '购买的产品',
        'CARGANDO': '正在加载产品列表',
        'NOMBREPULSO': '脉冲',
        'TIPOS': {
          'certificar': {
            'NOMBRE': '证明',
            'SUBTIPOS': {
              'v1': '认证 v1',
              'v2': '认证 v2.0',
              'v3': '认证 v3.0',
            }
          },
          'certificacionesAdicio': {
            'NOMBRE': '附加认证',
            'SUBTIPOS': {
              'v1Amco': '安科',
              'v2TD': '体面的工作',
              'v3PE': '第一份工作',
            }
          },
          'medir': {
            'NOMBRE': '措施',
            'SUBTIPOS': {
              'v1': '测量 v1',
              'v2': '措施改进',
              'v3': '测量 + MST',
              'v4': '按面积测量',
              'v5': '领导衡量',
              'v6': '按尺寸测量',
              'v7': '措施证明',
              'v8': '测量 3.0',
            }
          },
          'pulse': {
            'NOMBRE': '按检查',
            'SUBTIPOS': {
              'v1': '脉搏检查 v1.0',
              'v2': '脉搏检查 v3.0',
            }
          },
          'focus': {
            'NOMBRE': '重点地区',
            'SUBTIPOS': {
            }
          },
          'nom35': {
            'NOMBRE': 'NOM-035',
            'SUBTIPOS': {
              'v1': 'NOM-035',
              'v2': 'NOM-035 v3',
            }
          },
          'cgoExpress': {
            'NOMBRE': '文化快车',
            'SUBTIPOS': {
              'cgoExpress': '文化快车'
            }
          },
          'resulGoFlow': {
            'NOMBRE': 'goFlow 结果',
            'SUBTIPOS': {
              'resulGoFlow': 'goFlow 结果'
            }
          },
        }
      },
      'DETALLES': {
        'TITULO': '产品详情',
        'PRODUCTO': '产品:',
        'PROGRESO': '进步',
        'RESTANTE': '剩余时间',
        'DIASREST': '剩余天数:',
        'PANELFIJO': '显示为固定面板',
        'SURVEYTOKEN': '调查令牌',
        'ACCOUNT_ID': '帐户ID',
        'OPORTUNITY_ID': '机会 ID',
        'FECHAS': {
          'lanzamiento': '发布日期',
          'cierre': '最后期限',
          'prorroga': '延期日期',
          'recordatorio':'提醒事项',
          'avisos':'调查前沟通',
        },
        'AVANCES': {
          'NORMAL': '提前回复:',
          'MAS50': '超过 50 岁:',
          'MAS50_2': '超过 50 - 预先回答',
          'MENOS50': '50以下的预付款:',
          'MENOS50_2': '少于 50 - 提前回复'
        }
      },
      'CONTENIDO': {
        'BOTONES': {
          'VERPROD_1': '选择产品',
          'VERPROD_2': '查看其他产品',
          'OCULTAR': '隐藏'
        },
        'PREVIA': {
          'TITULO': '按产品分类的调查状态',
          'SUBTITULO': '该公司购买的产品列表显示在此屏幕左侧的菜单中。要查看每个产品的调查状态，请单击产品类别，然后选择年份。在此之后，将显示所选调查的详细信息，仅当所选产品已有初始化调查时',
          'CARGANDO': '正在检索所选产品的状态，请稍候'
        },
        'ESTADOS': {
          'NOCREADA': '此产品尚未创建调查',
          'NOINICIADA': '未启用调查'
        },
      },
      'COLABORADORES': {
        'TAB': '合作者名单',
        'CARGANDO': '正在加载合作者列表',
        'TABLA': {
          'TITULO': '合作者名单',
          'NOINFO': '无信息',
          'COLUMNAS': {
            'NOMBRE': '全名',
            'EMAIL': '电子邮件',
            'PASS': '密码',
            'STATUS': '实际状态',
            'FECHA_INI': '开始日期',
            'FECHA_FIN': '完成日期',
            'ACCIONES': '行动'
          },
          'TOOLTIPS': {
            'ACCIONES': '可用操作',
            'EMAILS': '电子邮件日志',
          },
        },
        'ACCIONES': {
          'TITULO': '可用操作',
          'LISTA': {
            'primerosColab': '查看前 1000 个',
            'buscarColab': '寻找合作者',
            'nuevoColab': '添加新的合作者',
            'enviaReco': '发送提醒',
            'bajarColab': '下载合作者名单',
          }
        },
        'SENDGRID': {
          'TITULO': '发送邮件日志',
          'SUBTITULO': '从列表中选择主题类型以显示已发送电子邮件的历史记录',
          'SELOPC': '选择一个选项',
          'INFOASUNTO': {
            'TITULO': '邮件信息',
            'CARD': {
              'from': '发给',
              'to': '从',
              'subject': '邮件主题'
            },
            'HISTORIAL': {
              'TITULO': '电子邮件提交历史',
              'SUBTITULO': '注意:列表中显示的日期/时间设置为当地时间',
              'VECESABIERTO': '营业时间',
              'ULTIMOEVENTO': '上次活动',
              'NORECORDS': '您的电子邮件历史记录不可用',
              'STATUS': {
                'ABIERTO': '邮件已发送',
                'NOENVIADO': '尚未发送'
              }
            }
          },
          'BOTONES': {
            'BACK': '回去'
          }
        },
        'ACCIONESUSUARIO': {
          'TITULO': '可用操作',
          'SUBTITULO': '以下列表显示了用户可用的操作列表',
          'CARGANDO': '加载可用操作',
          'LISTA': {
            'modificar': '修改选定协作者的数据',
            'borrar': '删除选定的协作者',
            'invitacion': '重新发送邀请',
            'recordatorio': '重新发送提醒',
            'respuestas': '删除调查回复',
            'resetSur': '重置调查访问权限',
          }
        },
        'MODALES': {
          'BUSCAR': '输入协作者姓名进行搜索',
          'BUSCAR_BOT': '搜索',
          'MINIMARECO': '提醒只能从调查开始之日起发送',
          'GENERAEXCEL': '生成协作者的excel文件，稍等',
          'NOANSWERS': '没有找到该参与者的回复',
          'ENVIOCORREO': '正在发送消息，请稍等',
          'BORRARESP': '正在删除该用户的回复，请稍等',
        },
        'EXCEL': {
          'TITUARCHIVO': '合作者名单',
          'COLUMNAS': {
            'name': '合作者姓名',
            'email': '电子邮件',
            'id_status': '调查状态',
            'start_date': '开始日期',
            'end_date': '完成日期',
          }
        }
      },
      'ACCIONES': {
        'TAB': '行动',
        'TITULO': '按类别可用的操作列表',
        'CATEGORIAS': {
          'encuesta': '民意调查',
          'filemanager': '文件管理器',
          'resultados': '結果',
          'webcompro': '网站上的公司简介',
        },
        'LISTA': {
          'surveyCheck': '检查调查',
          'surveyDown': '下载调查',
          'goSurvey': '去调查',
          'goCounting': '转到计数门户',
          'goCounting_more50': '前往计数门户 +50',
          'goCounting_less50': '前往计数门户 -50',
          'genCountingUrl': '生成到 Counts Portal 的外部链接',
          'copyCountingUrl': '将外部链接复制到 Counts 门户',
          'updateCounting': '与 Counts 门户同步',
          'addPro': '添加扩展',
          'verRecord': '记录的提醒',
          'surveyClose': '近距离调查',
          'surveyOpen': '公开调查',
          'processRes': '处理结果',
          'goPriv': '查看私人文件夹',
          'goPub': '查看公用文件夹',
          'verRes': '查看結果',
          'upNameIcon': '更新名称和徽标',
          'regCertifi': '重新生成证书',
          'goSurveyMas50': '转到调查 +50',
          'goSurveyMenos50': '转到调查 -50',
          'auditMan': '人工审核',
          'libeCultureBrief': '文化简报发布',
          'lockRes': '锁定结果',
          'verCultureAudit': '见文化审计',
          'verAvisos':'调查前沟通',
          'enviaCorreos': '手动发送电子邮件',
          'verWebComPro': '在网络上查看公司简介',
          'verFechIniCie': '开始/结束日期',
          'cancelarEnvios': '取消发送电子邮件',
          'verConfigResult': '结果配置',
          'descaDemo': '允许下载人口统计数据',
          'crearClave':'生成外部公司资料的密钥',
          'copyClave':'将密钥复制到外部公司资料',
          'verDatWPC':'查看外部公司资料访问数据',
          'confirReviCultureAudit':'确认文化审核审核',
          'cambiaCultureBrief': '文化审核简介产品链接'
        },
        'MODALES': {
          'URL': '链接已复制到剪贴板',
          'URL_CLA': '密钥已复制到剪贴板',
          'CHANGE_RESULT':'加載結果',
          'LOADINGMASTER': '正在从主表中检索信息，请稍等',
          'CONFIR_UPDA_NAM':'您确定要更新名称和徽标吗？',
          'CONFIR_REG_CERT':'您确定要重新生成证书吗？',
          'SUCC_UPDA_NAME':'成功更新',
          'UPDA_NAME_ICON':'更新数据',
          'UPDA_STA_ENC':'更新调查状态',
          'OBT_DAT_AUD_AUT':'获取审计信息',
          'WARNI_NOT_EXIT_TOKEN':'错误:令牌在 MT 中不存在',
          'CONFIR_REPRO_RESULT':'你确定要重新处理结果吗？',
           'MOD_INGRE_COD_PT1':'<span> 确认，在文本框中输入红色代码',
           'MOD_INGRE_COD_PT2':'</span>',
           'ERROR_CODIGO': '输入的代码与红色标示的不匹配',
           'CONFIR_LIBE_CULT_BRI':'你确定要发布文化简介吗？',
           'CONFIR_REVI_CULT_AUDIT':'您确定确认文化审核审核吗？',
           'NO_CONFIR_REVI_CULT_AUDIT':'确定取消文化审核审核？',
           'NO_CULT_BRI_ASOC':'没有发现相关的文化审计',
           'BLOQUEAR_1_1': '结果当前已解锁\n是否要锁定结果？',
           'BLOQUEAR_1_2': '输入结果被屏蔽的原因',
           'BLOQUEAR_2_1': '结果当前已锁定\n是否要解锁结果？',
           'BLOQUEAR_2_2': '写出结果被解锁的原因',
           'BLOQUEAR_3_1': '有必要说明更改的原因',
           'SINCRONIZARMT': '主表数据正在同步中，请稍等',
           'UPDA_DAT_RECOR': '更新提醒日期',
           'DELE_DAT_RECOR': '删除提醒日期',
           'UPDA_DAT_AVI': '通知日期更新',
           'DELE_DAT_AVI': '取消通知日期',
           'CANCELAR_ENVIOS': '您确定要取消预定的电子邮件吗？',
           'CANCELAR_ENVIOS_OK': '货件已成功取消。',
           'CANCELAR_ENVIOS_ERROR': '调查开始前两小时内无法取消配送。',
           'COM_CRE_ACCE_WCP_EXT': '您确定要为公司资料创建密钥吗？',
           'CRE_ACCE_WCP_EXT': '生成密码',
           'SUCC_CRE_ACCE_WCP_EXT': '密码生成成功',
           'TIT_MOD_VALI_ACCE_WCP_EXT': '继续：输入您的密码',
           'PLA1_MOD_VALI_ACCE_WCP_EXT': '您目前还剩 ',
           'PLA2_MOD_VALI_ACCE_WCP_EXT': ' 次尝试',
           'BTN_ACEP': '接受',
           'BTN_CAN': '取消',
           'WAR_ACCE_WCP_EXT': '输入的密码不正确',
           'LIMI_ACCE_WCP_EXT': '您已达到尝试次数上限',
           'DESAC_ACCE_WCP_EXT': '您的公司资料目前已停用',
           'ACTU_ACCE_WCP_EXT': '更新信息',
           'SUCC_ACTU_ACCE_ACCE_WCP_EXT': '更新成功',
           'CHANGE_WCP':'加载公司简介',
        },
        'SUBACCIONES': {
          'TITULO': '单击此处查看更多可用操作',
          'AUDMANUAL': {
            'TITULO': '人工审核',
            'NOMBRE': '审核员姓名',
            'NOTAS': '观察',
            'STATUS': {
              'ON': '接受审核',
              'OFF': '审核被拒绝'
            }
          },
          'verRes': {
            'tipoResu': {
              'TITULO': '更改结果版本类型',
              'MODAL': {
                'TITULO': '版本类型选择',
                'SUBTITULO': '选择此产品的结果版本类型',
                'SINCERT': '无证书版本',
                'CONCERT': '带证书的版本'
              }
            },
            'tipoResuV2': {
              'TITULO': '查看结果版本 2',
            },
          },
          'regCertifi': {
            'logoCert': {
              'TITULO': '更改证书徽标',
            },
            'previewCert': {
              'TITULO': '证书预览',
            },
            'multiSite': {
              'TITULO': '启用多站点证书文本',
            },
            'multiSiteText': {
              'TITULO': '查看多站点证书文本',
            },
          },
          'upNameIcon': {
            'logoEmpresa': {
              'TITULO': '更改公司标志'
            },
            'previewLogoEmp': {
              'TITULO': '标志预览'
            },
            'updateDatCerti': {
              'TITULO': '更改证书日期',
            }
          },
          'masterTable': {
            'syncMT': {
              'TITULO': '同步主表'
            }
          },
          'crearClave': {
            'visibleSwitchWCP': {
              'TITULO': '状态见外部公司简介',
            }
          },
          'verDatWPC': {
            'visibleSwitchWCP': {
              'TITULO': '状态见外部公司简介',
            }
          },
          'verWebComPro': {
            'updateStatusWCP': {
              'TITULO': '状态见网站上的公司简介',
            },
            'ESTA_WPC':{
              'ESTA_WPC_PU':'民众',
              'ESTA_WPC_NPU':'非公开',
            },
          },
          'cambiaCultureBrief': {
            'TITULO': '文化审核简介产品链接',
            'STATUS_SIN': '目前该产品没有链接的文化审计简报产品',
            'STATUS_CON': '目前已链接的产品',
            'BOTON_ELEGIR': '链接产品文化审核简介',
            'BOTON_ELEGIR_2': '确认',
            'BOTON_CAMBIAR': '与另一个产品链接文化审计简介',
            'LISTA_ELEGIR': '从列表中选择文化简介产品',
            'LISTA_DISPONIBLES': '可用产品',
            'SIN_OPCIONES': '没有可用的产品',
            'MESSAGE3': '<span>要确认所选的 Culture Audit Brief 产品链接，请在文本框中输入红色文本：',
            'MESSAGE4': '</span>',
            'MESSAGE5': '所选的 Culture Audit Brief 产品已成功链接到您的 Certify 产品',
            'VALIDAR': '确认',
            'SALIR': '取消',
            'ERRORNOMBREEMPRESA': '输入的文本与红色指示的文本不匹配',
            'CERRAR': '关闭',
          }
        }
      },
      'HISTORIAL_MAILS': {
        'TAB': '已发送电子邮件的历史记录',
        'TITULO': '为该产品发送的电子邮件列表',
        'TABLA': {
          'DESTINATARIO': '收件人',
          'ASUNTO': '邮件主题',
          'ESTADO': '当前状态',
          'VECES': '打开次数',
          'ULTIMO': '上次活动的日期',
          'FILTRO': '筛选',
          'INPUT_DEST': '按电子邮件地址过滤',
          'INPUT_ASU': '按主题过滤',
          'INPUT_STAT': '按状态过滤',
          'ELIJAOPCION': '- 从列表中选择一个选项 -',
          'NORESULTS': '没有找到记录',
          'LISTA_STATUS': {
            'delivered': '发送',
            'processed': '发货过程中',
            'not_delivered': '未发送'
          }
        },
        'ACCIONES': {
          'TITULO': '可用操作',
          'LISTA': {
            'enviaCorreos': '手动发送电子邮件',
            'getEnviados': '更新电子邮件发送历史',
          }
        },
        'MODAL': {
          'TITULO': '手工邮寄',
          'SUBTITULO': '您可以立即向此调查中的合作者发送特定类型的手动邮件',
          'INPUT': '选择邮件类型',
          'TIPOS': {
            '1': '邀请邮件',
            '2': '提醒邮件',
            '3': '开始调查前的第一通知',
            '4': '调查开始前的第二次通知',
            '5': '关闭邮件',
            '6': '发送给尚未开始调查的合作者的邮件',
            '7': '发送给已开始但尚未完成的协作者的邮件'
          },
          'BOTONES': {
            'BACK': '回去',
            'CONTINUAR': '继续',
            'SAVE': '保存审核',
          }
        },
        'MODALES': {
          'RECUPERANDO': '正在检索已发送邮件列表，请稍等',
          'SEND_EMA':'发送邮件',
          'SUCC_SEND_EMA':'邮件发送成功',
          'CONFIRMAR': '您是否确认向本次调查中的合作者发送所选类型的电子邮件？',
          'ENVIADOS': '邮件已成功发送，请尽快更新历史记录以查看已发送的邮件',
          'SI': '是的',
          'NO': '不',
          'UPDAT_HIST_EMA': '更新历史',
          'SUCC_UPDAT_HIST_EMA': '更新成功',
          'WAR_SEL_MAI': '要继续，请选择邮件类型',
          'WAR_SQL_ERROR': '回复时间已过，请重试',
        },
        'RESUMEN': {
          'TITULO': '概括',
          'TIPOS': {
            'totalEnviados': '开始的邮件总数',
            'delivered': '正确邮寄',
            'processed': '正在处理的邮件',
            'not_delivered': '未发邮件',
          }
        }
      },
      'AUDITORIA':{
        'TAB_TIT_AUDI':'调查审核',
        'TEX_AUDI_NOT_AUTORI': '审核被拒绝！',
        'TEX_AUDI_YE_AUTORI':'审核通过！',
        'TITL_AUDI_DEV_TR':'% Dev.Time 响应',
        'TITL_AUDI_DEV_PC':'% 开发。 问题控制',
        'TITL_AUDI_DEV_PA':'% 开发。 问题随机',
        'TIT_PAGI_TABL':'每页的文章。',
        'COLUMNAS':{
          'HierarchicalPath':'结构',
          'RespondentCount':'# 回应',
          'Time_DeviationCount':'# Desv T.Resp',
          'Time_DeviationPercentage':'% Desv T.Resp',
          'ControlStatement_DeviationCount':'# Desv P.控制',
          'ControlStatement_DeviationPercentage':'% Desv P.控制',
          'RandomStatement_DeviationPercentage':'# Desv P.随机的',
          'RandomStatement_DeviationCount':'% Desv P.随机的',

        }
      },
      'EMAI_LOG':{
        'TAB':'一般邮件历史',
         'TABLA_GLOBAL':{
           'TITU':'全局显示',
           'SUB_TIT':'总贡献者',
           'TH_1':'状态',
           'TH_2':'第一个通知',
           'TH_3':'第二次通知',
           'TH_4':'邀请',
           'TH_5':'提醒未开始的用户',
           'TH_6':'提醒未完成的用户',
           'enviados':'已发送',
           'procesando':'处理',
           'error':'错误',
           'VIE_DETA_TOOL':'查看详情',

        },
        'TABLA_COLAB':{
          'TITU_AV1_DELIV': '显示已发送警告 1 类邮件',
          'TITU_AV1_PROCC':'正在显示邮件类型通知 1',
          'TITU_AV1_N_DELIV':'错误显示邮件警告1的类型',

          'TITU_AV2_DELIV': '显示类型的邮件警告 2 发送',
          'TITU_AV2_N_DELIV':'错误显示邮件警告2的类型',
          'TITU_AV2_PROCC': '显示类型 2 通知 2 正在处理的邮件',

          'TITU_INV_DELIV':'发送邮件邀请的显示类型',
          'TITU_INV_PROCC': '显示正在处理的邀请邮件类型',
          'TITU_INV_N_DELIV': '显示邀请邮件类型错误',

          'TITU_REC1_DELIV':'显示已发送的提醒邮件类型 1',
          'TITU_REC1_PROCC':'显示正在处理的提醒邮件类型 1',
          'TITU_REC1_N_DELIV':'显示提醒1邮件类型错误',

          'TITU_REC2_DELIV':'显示已发送的提醒邮件类型 2',
          'TITU_REC2_N_DELIV':'显示错误提示邮件类型 2',
          'TITU_REC2_PROCC': '显示正在处理的提醒邮件类型 2',
          'SUB_TIT':'合作者总数',
          'TH_1':'状态',
          'TH_2':'贡献者姓名',
          'TH_3':'消息',
          'TH_4':'上一封电子邮件的日期',
          'TH_5':'邮件总数',
          'TH_6':'动作',
          'processed':'Processed',
          'delivered':'Delivered',
          'open':'Open',
          'bounce':'Bounced',
          'dropped':'Dropped',
          'TEX_SEARC_COLAB':'输入姓名或电子邮件',

         },
         'TEX_MOD_CHA_INFO':'加载信息',
        'CONT_MOD':{
          'TAB_TIT1':'邮件状态',
           'TAB_TIT2':'邮件视图',
           'TEX_CHA_INFO_GRAL':'加载信息',
           'TEX_ASUN':'主题:',
           'TEX_SELEC_EMA':'选择一个电子邮件',
           'TEX_CHA_INFO_EMA':'正在加载邮件信息',
           'H1_TIT_EMA_INFO':'电子邮件信息',
           'SPAN_SUB_TIT_DET':'详细信息',
           'TO':'至:',
           'FROM':'发件人:',
           'SUBJE':'主题',
           'MESS_ID':'消息ID:',
           'BTN_VER_MAS':'更多详情',
           'BTN_VER_MEN':'细节较少',
           'TIT_TEX_LIS':'事件历史',
           'SPAN_RECIV_SENGR':'由 SendGrid 接收',
           'SPAN_RECIV_FROM':'收到',
          'processed':'Processed',
          'delivered':'Delivered',
          'open':'Open',
          'bounce':'Bounced',
          'dropped':'Dropped',
          'deferred':'Deferred',
          'blocked':'blocked',
          'SPAN_DES_OPE_EMA':'收件人打开了这封邮件',
          'REASON':{
           'Bounced Address':'弹回地址',
          }

        }
      },
      'DAT_CERTI':{
        'TIT_MOD':'修改证书日期',
         'ING_DAT':'选择日期：',
         'ING_RAS':'输入修改日期的原因：',
         'BTN_SAV':'保存更改',
         'BTN_OK':'好的',
         'MOD_ING_REA':'输入日期更改的原因',
         'MOD_UPD_DAT':'更新证书日期',
         'SUCC_MOD_UPD_DAT':'更新成功',

      },
      'DAT_STAEND':{
        'TIT_MOD':'调查开始和结束日期',
         'SUB_TIT_MOD':'每个日期以当地时间显示在',
         'TEX_DA_STA':'开始日期',
         'TEX_DA_EN':'结束日期',
         'MOD_UPD_DA_DA_STA':'更新发布日期',
         'MOD_UPD_DA_EN':'更新结束日期',
         'SUCC_MOD_UPD_DA_DA_STA':'更新成功',
         'SUCC_MOD_UPD_DA_DA_EN':'更新成功',

      },
      'LANG_CERT':{
        'TIT_MOD':'选择语言：',
      },
    }
}
